import React, { Component } from 'react';
import { FaTimes } from "react-icons/fa";

import { fetchCaseDamages, fetchCurrentSettlementRate, fetchCasePurchaseDetails, fetchCurrentSettlementRateBands } from "../BasicDamageReport/store/actions";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import "./ClassWideDamageReport.css"
import PrintReport, { CASE_REPORT_TYPE } from "../../../common/components/PrintReport/PrintReport";
import DollarValueInflationContainer
	from "../../../common/components/DollarValueInflation/DollarValueInflationContainer";
import PrelimDamagesContainer from "../../../common/components/PrelimDamages/PrelimDamagesContainer";
import SettlementRateContainer from "../../../common/components/SettlementRate/SettlementRateContainer";
import SCAProbabilityContainer from "../../../common/components/SCAProbability/SCAProbabilityContainer";
import AdverseCorporateEventsContainer from "../../../common/components/AdverseCorporateEvents/AdverseCorporateEventsContainer";
import LiabilityLossComponent from "../../../common/components/LiabilityLoss/LiabilityLoss";
import LiabilityLossDistributionComponent from "../../../common/components/LiabilityLossDistribution/LiabilityLossDistribution";
import CoverageSufficiencyContainer from "../../../common/components/CoverageSufficiency/CoverageSufficiencyContainer";
import ProspectiveLossContainer from "../../../common/components/ProspectiveLoss/ProspectiveLossContainer";
import OfferingSeverityContainer from "../../../common/components/OfferingSeverity/OfferingSeverityContainer";
//import OfferingRetainedSharesContainer from "../../../common/components/OfferingRetainedSharesGraph/OfferingRetainedSharesContainer";
import Modal from "react-responsive-modal";
import styled from "styled-components";
import { Button } from "../../../common/components/Button";
import Disclosure from "../Disclosure";

const ButtonHolder = styled.div`
	margin-top: 10px;
`;

const LeftSideButton = styled(Button)`
	float: right;
`;

class ClassWideDamageReport extends Component {

	constructor(props) {
		super(props);
		this.state = {
			
			openBlock: false
		};
		this.onCloseBlockModal = this.onCloseBlockModal.bind(this);
		this.onDownloadClick = this.onDownloadClick.bind(this);
		this.findSettlementRateBand = this.findSettlementRateBand.bind(this);

	}
	componentDidMount() {
		let caseId = this.props.match.params.caseId;
		this.props.fetchCaseDamages(caseId);
		//this.props.fetchCasePurchaseDetails(caseId);

		this.setState({ openBlock: false });

	}

	onCloseBlockModal = () => {
		this.setState({ openBlock: false });
	}

	onDownloadClick = (props) => {
		if(props.purchaseType === "LICENSED_CASE" && props.currentCase.excelFile.length > 15) {
			window.location.href=props.currentCase.excelFile;	
		}
		else {
			this.setState({ openBlock: true });
		}
	}
	findSettlementRateBand = (bands, value) => {
		return bands.find(band =>
			value >= band.settlementRateBandMin &&
			(band.settlementRateBandMax === null || value < band.settlementRateBandMax)
		);
	}

// Usage:

	render() {

		let isDandO = sessionStorage.getItem('DANDO') || sessionStorage.getItem('ACEAlerts') || this.props.currentCase.claimTypeId === 3;
		let liabilityLossArr = [];
		//let sufficiencyArr = [];
		let meanLoss = 0;
		let medianLoss = 0;
		let median10Loss = 0;
		let median25Loss = 0;
		let median75Loss = 0;
		let median90Loss = 0;
		let aggDam = 0;
		let totProspLossMean = 0;
		let totProspLossMedian = 0;
		let tempRate = [];
		
		if(isDandO === "true" || this.props.currentCase.claimTypeId === 3 ) {

			tempRate[0] = {};
			tempRate[0].SCAProbabilityRateLabel = "12-Month Rule 10b-5 Probability Estimate";
			tempRate[0].SCAProbabilityRateValue = this.props.currentCase && this.props.currentCase.riskData && this.props.currentCase.riskData.scaProbability ? this.props.currentCase.riskData.scaProbability:null;
			tempRate[1] = {};
			tempRate[1].SCAProbabilityRateLabel = "Industry-Sector Rule 10b-5 Litigation Incidence (Avg.)";
			tempRate[1].SCAProbabilityRateValue = this.props.currentCase && this.props.currentCase.indsutrySCAProbaility ? this.props.currentCase.indsutrySCAProbaility:null;
			tempRate[2] = {};
			tempRate[2].SCAProbabilityRateLabel = "U.S. Public Company Rule 10b-5 Litigation Incidence (Avg.)";
			tempRate[2].SCAProbabilityRateValue = this.props.currentCase && this.props.currentCase.settlementRateMeanSuit? this.props.currentCase.settlementRateMeanSuit:null;
			if (this.props.currentCase && this.props.currentCase.aggregateDamages && this.props.currentCase.aggregateDamages[3] && this.props.currentCase.aggregateDamages[3].maxDollarOfArtificialInflationPerShare) {
				aggDam = this.props.currentCase.aggregateDamages[3].maxDollarOfArtificialInflationPerShare;
			}

			if (this.props.currentCase && this.props.currentCase.settlementRateBandMean) {
				meanLoss = aggDam * this.props.currentCase.settlementRateBandMean;
			}

			if (this.props.currentCase && this.props.currentCase.settlementRateBandMedian) {
				medianLoss = aggDam * this.props.currentCase.settlementRateBandMedian;
			}

			if(this.props.currentCase && this.props.currentCase.prospectiveLossMean) {
				for(let i=0;i<this.props.currentCase.prospectiveLossMean.length;i++)
					totProspLossMean += this.props.currentCase.prospectiveLossMean[i].estimatedLoss;
			}

			if(this.props.currentCase && this.props.currentCase.prospectiveLossMedian) {
				for(let i=0;i<this.props.currentCase.prospectiveLossMedian.length;i++)
					totProspLossMedian += this.props.currentCase.prospectiveLossMedian[i].estimatedLoss;
			}
			/*
			sufficiencyArr[0] = {};
			sufficiencyArr[0].name = "Embedded Rule 10b-5 Risk (Present Day)";
			sufficiencyArr[0].value = null;
			sufficiencyArr[0].isBold = true;

			sufficiencyArr[1] = {};
			sufficiencyArr[1].name = "Median Estimated Rule 10b-5 Loss (000s)";
			sufficiencyArr[1].value = medianLoss;
			sufficiencyArr[1].isBold = false;

			sufficiencyArr[2] = {};
			sufficiencyArr[2].name = "Mean Estimated Rule 10b-5 Loss (000s)";
			sufficiencyArr[2].value = meanLoss;
			sufficiencyArr[2].isBold = false;

			sufficiencyArr[3] = {};
			sufficiencyArr[3].name = "Prospective 12-Month Rule 10b-5 Risk (1-YR. Future Risk)";
			sufficiencyArr[3].value = null;
			sufficiencyArr[3].isBold = true;

			sufficiencyArr[4] = {};
			sufficiencyArr[4].name = "Median Estimated Rule 10b-5 Loss (000s)";
			sufficiencyArr[4].value = totProspLossMedian;
			sufficiencyArr[4].isBold = false;

			sufficiencyArr[5] = {};
			sufficiencyArr[5].name = "Mean Estimated Rule 10b-5 Loss (000s)";
			sufficiencyArr[5].value = totProspLossMean;
			sufficiencyArr[5].isBold = false;

			sufficiencyArr[6] = {};
			sufficiencyArr[6].name = "Estimated Potential Rule 10b-5 Loss Range";
			sufficiencyArr[6].value = null;
			sufficiencyArr[6].isBold = true;

			sufficiencyArr[7] = {};
			sufficiencyArr[7].name = "Median Rule 10b-5 Loss Estimate (000s)";
			sufficiencyArr[7].value = medianLoss + totProspLossMedian;
			sufficiencyArr[7].isBold = false;

			sufficiencyArr[8] = {};
			sufficiencyArr[8].name = "Mean Rule 10b-5 Loss Estimate (000s)";
			sufficiencyArr[8].value = meanLoss + totProspLossMean;
			sufficiencyArr[8].isBold = false;
			*/
			if(!this.props.currentCase.settlementRateBand || this.props.currentCase.settlementRateBand.settlementRate90Value === null) {
				liabilityLossArr[0] = {};
				liabilityLossArr[0].name = "Potential Rule 10b-5 Aggregate Damages (000s)";
				liabilityLossArr[0].loss = aggDam;
				liabilityLossArr[1] = {};
				liabilityLossArr[1].name = "";
				liabilityLossArr[1].loss = null;
				liabilityLossArr[2] = {};
				liabilityLossArr[2].name = "Median Estimated Rule 10b-5 Loss (000s)";
				liabilityLossArr[2].loss = medianLoss;
				liabilityLossArr[3] = {};
				liabilityLossArr[3].name = "Mean Estimated Rule 10b-5 Loss (000s)";
				liabilityLossArr[3].loss = meanLoss;
			} else {
				liabilityLossArr = [];
			}
			
		}



		return (
			<React.Fragment>
				<div className={"nonePrinted"}>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div className={"PageHeader"}>{this.props.currentFillingName} {isDandO === "true" || this.props.currentCase.claimTypeId === 3 || this.props.currentCase.claimTypeId === 4 ? "Securites Litigation Risk & Loss Analysis" : this.props.currentCase.caseRuleTypeId === 3? "Estimate of Potential Section 11 Severity" : "Estimate of Potential Rule 10b-5 Severity"} 
						</div>
						
						{ isDandO === "true" || this.props.currentCase.claimTypeId === 3 || this.props.currentCase.claimTypeId === 4 || (this.props.currentCase.excelFile === "" && this.props.purchaseType === "LICENSED_CASE")? "" :
							<button onClick={() => this.onDownloadClick(this.props) } className={"printButton"} >Download</button>
						}
						{/* isDandO === "true" || this.props.purchaseType === "LICENSED_CASE" ? "" :
							<button onClick={() => window.print()} className={"printButton"} >Print</button>
						*/}
						<Modal
							open={this.state.openBlock}
							onClose={this.onCloseBlockModal}
							focusTrapped={true}
							styles={{ modal: {width: "60%", height: "60%", overflow: "auto" } }}
						>
							<div className="ModalWindow modaladd">
								<FaTimes className="closeicon" onClick={this.onCloseBlockModal} />
								<br />
								<div className="modalHeading"></div>
								<div className="NavDivider"></div>
								<Disclosure />
								<div className="NavDivider"></div>
								<div>
									<div className="NavDivider"></div>
									<ButtonHolder>
										<LeftSideButton
											onClick={evt => {
												window.open("https://www.sarlit.com/contact-us", "_blank");
											}}
											hoverBorderColor="#83bed3"
											tabIndex="-1"
										>
											Contact Us
										</LeftSideButton>
									</ButtonHolder>

								</div>
							</div>
						</Modal>
					</div>
					
					{ isDandO === "false" &&  this.props.currentCase.caseRuleTypeId === 3? 
						<OfferingSeverityContainer
							classPeriodOfferings={
								this.props.currentCase.offering
							}
							offeringExposures={
								this.props.currentCase.offeringExposure
							}
						/>
						
						:
						"" 
					}
					
					{ isDandO === "true" || this.props.currentCase.caseRuleTypeId === 3 ?
						""
						:
						<DollarValueInflationContainer dollarValueInflations={this.props.currentCase.dollarValueInflations} />
					}	
					
					{ isDandO === "true" && this.props.currentCase && this.props.currentCase.riskData && this.props.currentCase.riskData.scaProbability ?
						<SCAProbabilityContainer SCAProbabilityRate={tempRate} /> 
						:
						""
					}
					{ isDandO === "true" && this.props.currentCase && this.props.currentCase.adverseCorporateEvent ?
						
						<AdverseCorporateEventsContainer adverseCorporateEvents={this.props.currentCase.adverseCorporateEvent} />
						:
						""
					}					
					{ isDandO === "true" && this.props.currentCase && this.props.currentCase.potentialLoss && this.props.currentCase.settlementRateBand && this.props.currentCase.settlementRateBand.settlementRate90Value ?
						<LiabilityLossDistributionComponent liabilityLoss={this.props.currentCase.potentialLoss} liabilityRates={this.props.currentCase.settlementRateBand} />
						:
						isDandO === "true" && this.props.currentCase && liabilityLossArr ?
						
						<LiabilityLossComponent liabilityLoss={liabilityLossArr} />
						:
						""
					}

					{ isDandO === "true" && this.props.currentCase && this.props.currentCase.prospectiveLossMedian ?
						<ProspectiveLossContainer prospectiveLosses={this.props.currentCase.prospectiveLossMedian} lossType={"Median"} />
						:
						""
					}
					{ isDandO === "true" && this.props.currentCase && this.props.currentCase.prospectiveLossMean ?
						<ProspectiveLossContainer prospectiveLosses={this.props.currentCase.prospectiveLossMean} lossType={"Mean"} />
						:
						""
					}

					{ isDandO === "true" || this.props.currentCase.caseRuleTypeId === 3 ? 
						"" 
						:
						<PrelimDamagesContainer aggregateDamages={this.props.currentCase.aggregateDamages} aggregateDamagesNOPSLRA={this.props.currentCase.aggregateDamagesNOPSLRA} classFloatAverages={this.props.currentCase.classFloatAverages} isDandO={isDandO} caseRuleTypeId={this.props.currentCase.caseRuleTypeId} currentSettlementRateBands={this.props.currentSettlementRateBands} />
					}
					{ isDandO === "true" ? 
						"" 
						:
						<SettlementRateContainer currentSettlementRateBands={this.props.currentSettlementRateBands} caseRuleTypeId={this.props.currentCase.caseRuleTypeId} />
					}
				</div>
				<PrintReport classPeriodTradingStats={this.props.currentCase.classPeriodTradingStats}
					marketCapitalizationLosses={this.props.currentCase.marketCapitalizationLosses}
					statResidualReturns={this.props.currentCase.statResidualReturns}
					dollarValueInflations={this.props.currentCase.dollarValueInflations}
					aggregateDamages={this.props.currentCase.aggregateDamages}
					aggregateDamagesNOPSLRA={this.props.currentCase.aggregateDamagesNOPSLRA}
					classFloatAverages={this.props.currentCase.classFloatAverages}
					currentCaseId={this.props.currentCaseId}
					currentFillingName={this.props.currentFillingName}
					docketNumber={this.props.docketNumber}
					type={CASE_REPORT_TYPE}
					stockPrices={this.props.currentCase.stockPrices}
					purchaseTime={this.props.purchaseTime}

				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		currentCase: state.currentCase.currentCase,
		currentCaseId: state.currentCase.caseId,
		currentFillingName: state.currentCase.fillingName,
		docketNumber: state.currentCase.docketNumber,
		settlementRate: state.currentCase.currentCase.settlementRate,
		settlementRates: state.currentCase.settlementRates,
		currentSettlementRate: state.currentCase.currentSettlementRate,
		currentSettlementRateBands: state.currentCase.currentSettlementRateBands,
		purchaseTime: state.currentCase.purchaseTime,
		purchaseType: state.currentCase.purchaseType,


	}
};

const mapDispatchToProps = dispatch => {
	return {
		fetchCaseDamages: (caseId) => {
			dispatch(fetchCaseDamages(caseId));
			dispatch(fetchCurrentSettlementRate());
			dispatch(fetchCurrentSettlementRateBands());
			dispatch(fetchCasePurchaseDetails(caseId));

		},
	}
};



export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ClassWideDamageReport));


// WEBPACK FOOTER //
// ./src/components/DamageReports/ClassWideDamageReport/ClassWideDamageReport.js